import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Orbit.scss';
const Orbit = ({ size = 35, color = 'black', speed = 1.5, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner }) }));
};
export default Orbit;
